import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import SignWays from './components/SignWays'
import PhoneForm from './components/PhoneForm'
import EmailForm from './components/EmailForm'
import { preFixImgUrl } from '@/utils'

const SignIn = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const [activeSignInType, setActiveSignInType] = useState('phone')
  const [protocolChecked, setProtocolChecked] = useState(false)
  
  return (
    <div className='bg-[#eff6ff] min-h-screen flex flex-col items-center justify-center leading-[1.5]'>
      <div className='flex w-8xl mx-auto px-10 justify-between items-center'>
        <div className='flex flex-col  items-center'>
          <LangText lngKey='36bbc3e4' className='text-[32px] font-bold'>{t('36bbc3e4')}</LangText>
          <img src={preFixImgUrl('911ee3d2540af545a5b891d522b69141.png')} className='w-[576px] h-[451px] mt-[27px]' />
        </div>
        <div id='sign-form' className='w-[486px] min-h-[580px] px-[38px] bg-white rounded-[12px] shadow-[0px_8px_18px_0px_rgba(18,37,196,0.06)] pt-10 flex flex-col justify-start'>
          <LangText lngKey='50735985' className='text-[24px] font-bold '>{t('50735985')}</LangText>
          <LangText lngKey='5dac87dc' className='text-[16px] text-[#666666] font-normal  mt-[4px]'>{t('5dac87dc')}</LangText>
          <SignWays value={activeSignInType} onChange={setActiveSignInType}/>
          {
            activeSignInType === 'phone' && <PhoneForm protocolChecked={protocolChecked} setProtocolChecked={setProtocolChecked}/>
          }
          {
            activeSignInType === 'email' && <EmailForm protocolChecked={protocolChecked} setProtocolChecked={setProtocolChecked}/>
          }
        </div>
      </div>
      <span className='text-[12px] text-[#666666] absolute bottom-10'>© {year} JapanDX. All rights reserved.</span>
    </div>
  )
}
export default SignIn